import { api } from '$app/api';

export const getPathfinderJourneys = async (params) => {
  const { data } = await api.get('/journeys', { params });
  return data;
};
